import React, { useState } from "react";

import { CENTRAL_ROLES } from "../constants";
import { useAuth } from "../context/AuthContext";

export default function KistenAccessDeniedPage() {
  const { error, refreshPermissions, logout, hasAnyRole } = useAuth();
  const [refreshing, setRefreshing] = useState(false);
  const [refreshError, setRefreshError] = useState("");
  const hasAccess = hasAnyRole([
    CENTRAL_ROLES.KISTEN_SUPERVISOR,
    CENTRAL_ROLES.KISTEN_PLANNING,
    CENTRAL_ROLES.KISTEN_ADMIN,
  ]);

  const refresh = async () => {
    setRefreshing(true);
    setRefreshError("");
    try {
      await refreshPermissions();
    } catch {
      setRefreshError("Vernieuwen is niet gelukt. Controleer de verbinding en probeer opnieuw.");
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <main className="min-h-screen bg-green-50 p-6 flex items-center justify-center">
      <section className="w-full max-w-lg rounded-lg border border-amber-200 bg-white p-6 shadow">
        <h1 className="mb-3 text-2xl font-bold">Geen toegang tot Kisten</h1>
        <p className="mb-3">
          {error?.message || "Je bent ingelogd, maar je account heeft geen Kisten-rechten."}
        </p>
        {hasAccess && (
          <p className="mb-3 text-sm text-amber-800">
            Je centrale Kisten-rol is aanwezig. Vernieuw je rechten en probeer opnieuw.
          </p>
        )}
        {refreshError && <p className="mb-3 text-sm text-red-700" role="alert">{refreshError}</p>}
        <div className="flex flex-wrap gap-3">
          <button type="button" onClick={refresh} disabled={refreshing}
            className="rounded bg-green-800 px-4 py-2 font-semibold text-white disabled:opacity-60">
            {refreshing ? "Rechten vernieuwen..." : "Rechten vernieuwen"}
          </button>
          <button type="button" onClick={logout}
            className="rounded bg-gray-200 px-4 py-2 font-semibold">
            Uitloggen
          </button>
        </div>
      </section>
    </main>
  );
}
